import { Component, type ReactNode } from "react";
import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

type Props = { children: ReactNode; resetKey?: string };
type State = { error: Error | null };

// Keeps one failing view (e.g. an engine that 500s on an un-enriched company)
// from white-screening the whole app.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <Card>
          <CardContent className="flex items-start gap-3 py-6 text-sm">
            <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-destructive" />
            <div>
              <div className="font-medium text-destructive">This view could not render</div>
              <div className="mt-1 text-muted-foreground">
                {this.state.error.message ||
                  "Something went wrong. This usually means the company has not finished syncing yet."}
              </div>
            </div>
          </CardContent>
        </Card>
      );
    }
    return this.props.children;
  }
}
